import api from 'api'
import { CACHE_TAG_BILLING_PAYMENT_BATCH_BY_ID, CACHE_TAG_BILLING_PAYMENT_BATCH_LIST } from 'api/cacheTagTypes'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    postPaymentBatch: build.mutation({
      query: body => ({
        url: `/api/v1/billing/payment/draft/post-draft/${body.id}`,
        method: 'POST',
        body,
      }),
    }),
    createUpdateDraftBatch: build.mutation({
      query: body => ({
        url: '/api/v1/billing/payment/draft/create-update-draft',
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error, { id }) => [CACHE_TAG_BILLING_PAYMENT_BATCH_LIST],
    }),
    archivePaymentBatch: build.mutation({
      query: id => ({
        url: `/api/v1/billing/payment/draft/archive/${id}`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, id) => [{ type: CACHE_TAG_BILLING_PAYMENT_BATCH_BY_ID, id }],
    }),
    getPaymentBatch: build.query({
      query: batchId => ({
        url: `/api/v1/billing/payment/draft/batch/${batchId}`,
        method: 'GET',
      }),
      providesTags: (result, error, batchId) => [{ type: CACHE_TAG_BILLING_PAYMENT_BATCH_BY_ID, id: batchId }],
    }),
    getPaymentBatchDetail: build.query({
      query: batchId => ({
        url: `/api/v1/billing/payment/batch/${batchId}`,
        method: 'GET',
      }),
    }),
    getPaymentBatchList: build.query({
      query: params => ({
        url: '/api/v1/billing/payment/draft/list-batches',
        method: 'GET',
        params: {
          ...params,
          showArchived: params?.showArchived ?? false,
        },
      }),
      providesTags: [CACHE_TAG_BILLING_PAYMENT_BATCH_LIST],
    }),
  }),
})

export const {
  usePostPaymentBatchMutation,
  useCreateUpdateDraftBatchMutation,
  useArchivePaymentBatchMutation,
  useLazyGetPaymentBatchQuery,
  useLazyGetPaymentBatchDetailQuery,
  useLazyGetPaymentBatchListQuery,
} = extendedApi
